import Vue from "vue";
import { Watch, Component, Prop } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
const namespace: string = "profile";

import * as d3 from "d3";
import * as moment from "moment";

import { LinkingNode } from "../../scripts/common/ah.mb.common.node-object";
import { Clipboard } from "../../scripts/ah.mb.clipboard";
import { ClientNotifier, IBasicCommandResponse } from "../../scripts/ah.mb.client-notifications";
import { ModelNotifier } from "../../scripts/model-notifier";
import { INodeName, modelServices } from "../../scripts/ah.mb.ui.model-services";
import { DefaultLinkRules } from "../../scripts/ah.mb.default-link-rules";
import { LinkValidator } from "../../scripts/ah.mb.link-validator";
import { ModelUtils } from "../../scripts/ah.mb.ui.model-utils";
import { DefaultModelActionsHandler } from "../../scripts/model-notifier/ah.mb.common.default-model-actions-handler";
import { bootbox } from "../../infrastructure/bootbox-shim";
import { NodeObject } from "../../scripts/common/ah.mb.common.node-object";
import { ReportServices } from "../../scripts/ah.mb.report-services";
import { NetworkDiagramState } from "../../scripts/ah.modelbuilder.network-diagram-state";
import { ModelNavStack } from "../../scripts/ah.mb.model-nav-stack";
import { RecentlyVisitedPages, PageType } from "../../scripts/common/ah.mb.common.stored-stack";
import { HandsontableRenderer } from "../../scripts/ah.mb.ui.HandsontableRenderer";
import { AttachmentsTableRenderer } from "../../scripts/attachments/ah.mb.attachments-table";
import { NodeDefs } from "../../scripts/ah.modelbuilder.node-defs";
import { NetworkDiagramBuilder, IOldNodeIcon, NodeDistributionMode, NetworkDiagramConfig, DiagramForceSimulationConfig } from "../../scripts/ah.mb.ui.network-diagram";
import { ModelTree } from "../../scripts/ah.mb.model-tree";
import { FetchWrapper } from "../../infrastructure/fetch-wrapper";
import { MethodDelayer } from "../../scripts/common/ah.mb.common.method-delayer";
import { ViewManager, GridLayouter, ViewDef } from "../../scripts/ah.mb.ui.view-builders";
import { GoogleChartRenderer } from "../../scripts/ah.mb.googleChartRenderer";
import { ISelectCommodityOptions, ICommoditySelector } from "../../entities/select-commodity-options";
import { CommodityAndUnitsRec } from "../../scripts/ah.mb.commodity-and-units-rec";
import { IEditNodeDataModel } from "../../entities/edit-node-data-model";
import { ISearchAndReplaceSettings } from "../../entities/search-and-replace-settings";
import { IExportNodeDataModel } from "../../entities/export-node-data-model";
import { IUploadNodeDataInfo } from "../../entities/nu-model-info";
import { VueGridLayouter, ILayoutCellObject } from "../../scripts/vue-grid-layouter";
import { IReportCarouselConfig } from "../report-carousel/report-carousel";
import { IUploadModelAttachmentInfo } from "../upload-attachment-dialog/upload-attachment-dialog";
import { ITagObject } from "../../entities/tag-object";
import { IModelActionsHandler } from "../../scripts/model-notifier/ah.mb.common.model-actions-handler";
import { ILinkDataModel } from "../link-data-dialog/link-data-dialog";
import { ICreateModelNodeModel } from "../create-model-node-dialog/create-model-node-dialog";
import { INodeObject } from "../../scripts/common/ah.mb.common.node-object";
import { IDownloadReportsModel } from "../../entities/download-reports-model";
import { INodePathAndName } from "../../scripts/common/ah.mb.common.node-object";
import { SvgExporter } from "../../scripts/ah.mb.svg-exporter";
import { IZipBuilder, ZipBuilder } from "../../scripts/IZipBuilder";
import { IExportNetworkDiagramConfig } from "../export-network-diagram-dialog/export-network-diagram-dialog";
import { IDistributeDiagramNodesOptions } from "../distribute-diagram-nodes-dialog/distribute-diagram-nodes-dialog";
import { INetworkDiagramOptions } from "../network-diagram-options-dialog/network-diagram-options-dialog";
import { GlobalEventEmitter } from "../../infrastructure/global-event-emitter";
import { StringUtils } from "../../scripts/ah.mb.model-utils";
interface IViewType {
    name: string;
    rootNode: string;
    lastVisitedTreeNode: string;
    sectorNodeType: string;
}

class CommoditySelector implements ICommoditySelector {

    private readonly showSelectCommodityDialogFunc: (commodityRec: CommodityAndUnitsRec,
        linkProps: string,
        callback: (result: CommodityAndUnitsRec, newProps: string) => void) => void;

    constructor(showSelectCommodityDialogFunc: (commodityRec: CommodityAndUnitsRec,
        linkProps: string,
        callback: (result: CommodityAndUnitsRec, newProps: string) => void) => void) {

        this.showSelectCommodityDialogFunc = showSelectCommodityDialogFunc;
    }

    selectCommodity(
        commodityList: Array<CommodityAndUnitsRec>,
        linkProps: string,
        callback: (result: CommodityAndUnitsRec, newProps: string) => void) {

        switch (commodityList.length) {
            // Prompt user
            default:
                const newCommodity = { commodity: "", units: "" };
                const newProps = "";
                this.showSelectCommodityDialogFunc(newCommodity, newProps, callback);
                break;

            // Simple case - only one option
            // Default to no properties
            case 1:
                callback(commodityList[0], linkProps);
                break;
        }
    }

    editCommodity(commodity: CommodityAndUnitsRec,
        linkProperties: string,
        callback: (result: CommodityAndUnitsRec, newProps: string) => void) {
        this.showSelectCommodityDialogFunc(commodity, linkProperties, callback);


    }
}

interface INodeTemplate {
    pathAndName: string;
    name: string;
}

@Component
export default class ModelViewer extends Vue {

    @Action("setCurrentModelId", { namespace: namespace })
    setCurrentModelId: any;

    @Action("setCurrentNodePath", { namespace: namespace })
    setCurrentNodePath: any;

    @Getter("nodeModifiedNotification", { namespace: namespace })
    nodeModifiedNotification: string;


    @Prop()
    modelId: string;

    rootNode: string = "";

    @Prop()
    targetSector: string;

    private previousCommodity: string = "";
    private previousUnits: string = "";

    private selectCommodityOptions: ISelectCommodityOptions;
    private showSelectCommodityDialog: boolean;

    private showUploadNodeDataDialog = false;
    private uploadNodeDataInfo: IUploadNodeDataInfo;

    showUploadAttachmentDialog = false;
    uploadAttachmentModel: IUploadModelAttachmentInfo = { modelId: "", fileName: "" }

    commentsNodePathAndName: string = "";

    rawNodeEditorNodePathAndName: string = "";

    undoPeekCmd: any = null;
    redoPeekCmd: any = null;

    // Dashboard stuf
    private showPublishToDashboardDialog = false;
    private publishToDashboardModel: INodePathAndName = {
        nodePathAndName: "", modelId: ""
    };


    /**
     * Used to callback to the network diagram when the select commodity for link dialog is accepted
     * @param result 
     * @param newProps 
     * @returns {} 
     */
    private commoditySelectedCallback: (result: CommodityAndUnitsRec, newProps: string) => void;


    private editNodeDataModel: IEditNodeDataModel = { modelId: "", nodePathAndName: "" };
    private showEditNodeDataDialog: boolean;

    linkDataModel: ILinkDataModel = { modelId: "", sourceNodePathAndName: "", destNodePathAndName: "" }
    showLinkDataDialog: boolean = false;

    private searchAndReplaceSettings: ISearchAndReplaceSettings = {
        modelId: "",
        rootNode: "",
        replaceText: "",
        searchText: "",
        targetType: "Node names"
    }
    showSearchAndReplaceDialog: boolean;

    exportNodeDataModel: IExportNodeDataModel = {
        modelId: "", nodePathAndName: "", includeSubRegions: true,
        excludeTags: [], tags: [], tagsAndOr: "and",
        variableNames: [], nodeTypes: []
    };
    showExportNodeDataDialog: boolean;


    // Objects for node chart cells
    nodeChartsLayouter: GridLayouter;
    nodeChartsCellObjects: Array<ILayoutCellObject> = [];

    // Objects for node tables cells
    nodeTablesLayouter: GridLayouter;
    nodeTablesCellObjects = [];

    // Objects for node maps cells
    nodeMapsLayouter: GridLayouter;
    nodeMapsCellObjects = [];

    // Objects for node i/o view cells
    nodeIoViewsLayouter: GridLayouter;
    nodeIoViewsCellObjects: Array<ILayoutCellObject> = [];

    showReportCarousel: boolean = false;
    reportCarouselConfig: IReportCarouselConfig = {
        modelId: "",
        subject: "",
        reportTypeFilter: "All",
        initialViewName: "",
        nodeCommodities: null

    }

    // Node tags
    tag: string = "";
    tags: Array<ITagObject> = [];
    tagAutoCompleteDebounce = null;
    nodeTagAutocompleteItems: Array<ITagObject> = [];

    nodeTemplates: Array<INodeTemplate> = [];

    createModelNodeModel: ICreateModelNodeModel = {
        modelId: "",
        nodeName: "",
        numStates: 1,
        numSubTimes: 1,
        numTimePoints: 10,
        startTimePoint: 2018
    };
    showCreateModelNodeDialog: boolean = false;

    viewTypes: IViewType[] = [
        { name: "Model", rootNode: "\\Root", lastVisitedTreeNode: "", sectorNodeType: "Sector" },
        { name: "Node Templates", rootNode: "\\Templates", lastVisitedTreeNode: "", sectorNodeType: "Template" },
        { name: "Records Exports", rootNode: "\\RecordsExports", lastVisitedTreeNode: "", sectorNodeType: "RecordsExportDefinition" }

    ];
    currentViewType: IViewType = this.viewTypes[0];

    downloadReportsModel: IDownloadReportsModel =
        {
            mode: "bySubjectNode", modelId: "", createPivots: false, format: "excel", reportNodePathAndNames: [], singleSheet: false,
            recursive: false,
            reportNames: []
        }
    showDownloadReportsDialog: boolean = false;

    exportNetworkDiagramConfig: IExportNetworkDiagramConfig =
        {
            modelId: "",
            recurseSectors: false,
            centerDiagrams: true,
            rootSector: ""
        }
    showExportNetworkDiagramDialog: boolean = false;

    distributeDiagramNodesOptions: IDistributeDiagramNodesOptions =
        {
            distanceX: 50,
            distanceY: 50,
            modeStr: "horizontally"
        }
    showDistributeDiagramNodesDialog: boolean = false;

    diagramOptions: INetworkDiagramOptions =
        {
            snapNodesToGrid: true,
            snapGridSize: 50,
            autoCreateKinkPoints: true
        }
    showDiagramOptionsDialog: boolean = false;


    data() {
        return {
            selectCommodityOptions: this.selectCommodityOptions,
            showSelectCommodityDialog: this.showSelectCommodityDialog,
            showEditNodeDataDialog: this.showEditNodeDataDialog,
            editNodeDataModel: this.editNodeDataModel,
            searchAndReplaceSettings: this.searchAndReplaceSettings,
            showSearchAndReplaceDialog: this.showSearchAndReplaceDialog,
            exportNodeDataModel: this.exportNodeDataModel,
            showExportNodeDataDialog: this.showExportNodeDataDialog,

            showUploadNodeDataDialog: this.showUploadNodeDataDialog,
            uploadNodeDataInfo: this.uploadNodeDataInfo,
            showPublishToDashboardDialog: this.showPublishToDashboardDialog
            //            publishToDashboardModel: this.publishToDashboardModel

            //showReportCarousel: this.showReportCarousel

        }
    }

    private commoditySelector: ICommoditySelector;

    private notificationRect = 0;


    // A place to remember a cross-region link selection
    private linkingNode = new LinkingNode(); //


    // Model tree clipboard
    // Get rid of the above one in favor of this eventually
    private clipboard = new Clipboard();

    // Create user notifier
    private userNotifier = new ClientNotifier();


    // Selected nodes array - can be selected by tree or diagram, based on whatever was clicked last
    private selectedNodes: Array<NodeObject> = [];
    private ioDiagramSelectedNodes = [];

    private diagram: NetworkDiagramBuilder;
    private ioDiagram: NetworkDiagramBuilder;

    private tree = null; // Old
    private modelTree: ModelTree = null; // New

    // Model change observer
    private modelObserver = new ModelNotifier();

    // Node tag editor
    //private nodeTagsTypeaheadUrl = `/api/1.0/nodetags/suggestions?modelId=${this.modelId}&searchterm=%QUERY`;
    //private nodeTagEditor: NodeTagsEditor;

    // Create modelServices
    private modelServices = new modelServices(this.modelObserver);

    // Create scriptServices
    private reportServices = new ReportServices(this.modelObserver);

    // Client side model logic
    // Awkward composition here
    private linkRules = DefaultLinkRules.getRules();
    private linkValidation = new LinkValidator(this.linkRules);
    private modelValidation = new ModelUtils(this.linkValidation);

    // Server side model validation
    // Not currently used
    //var validationServices = new AH.MB.ModelValidation.ApiServices(userNotifier);

    // To store he current diagram position and scale
    private diagramState = new NetworkDiagramState();
    private ioDiagramState = new NetworkDiagramState();

    // The initial focus node in the diagram if any
    private nodeToFocusInDiagram = null;

    // Navigation stack
    private navStack = new ModelNavStack();

    // Attachments table renderer
    private attachmentsTableUrl = "/attachments/attachmentsdt";
    attachmentsTabeleAjaxSettings: DataTables.AjaxSettings;
    attachmentsTableRenderer: AttachmentsTableRenderer = null;



    /**
     * Update if model param in route changed
     * @param oldVal
     * @param newVal
     */
    @Watch("$route.params.modelId")
    routeModeIdChanged(newVal) {
        // Assume they want to look at the model, not templates or something
        this.loadModel();

    }

    // Node data spreadsheet renderer
    // Handsontable spreadsheet renderer
    private nodeDataSpreadsheetRenderer = new HandsontableRenderer(
        {
            data: [],
            copyPaste: true,
            //renderAllRows: true,
            afterChange:
                (changes, source) => {
                    // After change handler
                    if (source !== "loadData") {
                        // Enable save/cancel spreadsheet changes button
                        $("#saveNodeSpreadsheetChangesButton").toggleClass("disabled", false);
                        $("#cancelNodeSpreadsheetChangesButton").toggleClass("disabled", false);
                    }
                }

            //colWidths: 10,
            //colHeight: 4,
            //stretchH: "all"
        });

    // Initial tree lazy mode
    private modelTreeIsLazy = true;
    private modelTreeFilter = "";

    // Diagram builders
    private diagramBuilder: NetworkDiagramBuilder = null;

    // Model actions handler
    modelActionsHandler: IModelActionsHandler = null;

    selectCommodityDialogAccepted(dialogResult: string) {
        if (dialogResult === "ok") {

            // Cache previous commodity
            this.previousCommodity = this.selectCommodityOptions.commodityToEdit.commodity;
            this.previousUnits = this.selectCommodityOptions.commodityToEdit.units;

            this.commoditySelectedCallback(this.selectCommodityOptions.commodityToEdit,
                this.selectCommodityOptions.linkProps);
        }
    }

    loadModel() {
        this.setCurrentModelId(this.modelId);

        // Set current view type back to 0
        this.currentViewType = this.viewTypes[0];
        this.currentViewType.lastVisitedTreeNode = localStorage.getItem(`modelTree_ActiveNode_${this.modelId}`);

        // Add page to recent list
        if (this.modelId) {
            const recentItemsStore = new RecentlyVisitedPages();
            recentItemsStore.stack.add(
                {
                    modelId: this.modelId,
                    pageType: PageType.Viewer,
                    name: this.modelId + " | Viewer",
                    visitedDate: new Date()
                });
        };

        this.setupTimePointControl(this.modelId);
        this.setupSubTimeControl(this.modelId);

        this.modelActionsHandler = new DefaultModelActionsHandler(
            this.modelId,
            this.modelServices,
            this.userNotifier,
            this.clipboard);


        this.attachmentsTabeleAjaxSettings =
        {
            url: this.attachmentsTableUrl,
            method: "POST",
            global: false, // Suppress global ajax notification
            data: (d: any) => { d.modelId = this.modelId; }
        };


        // Attach paste handler
        document.addEventListener("paste", this.documentPasteHandler);

        this.attachmentsTableRenderer = new AttachmentsTableRenderer(this.attachmentsTabeleAjaxSettings);


        this.populateNodeTemplates(this.modelId);

        this.populateTree();

        this.refreshUndoRedo(this.modelId);


    }

    /**
     * Before route leave handler
     * @param from
     * @param to
     * @param next
     */
    beforeRouteLeave(from, to, next) {
        // Detatch paste handler so it doesn't get fired after we have left this page
        document.removeEventListener("paste", this.documentPasteHandler);
        next();
    }

    mounted() {


        this.commoditySelector = new CommoditySelector(
            (commodityRec: CommodityAndUnitsRec,
                linkProps: string,
                callback: (result: CommodityAndUnitsRec, newProps: string) => void) => {

                if (commodityRec.commodity === "")
                    commodityRec.commodity = this.previousCommodity;
                if (commodityRec.units === "")
                    commodityRec.units = this.previousUnits;

                this.selectCommodityOptions = {
                    title: "Select Commodity",
                    commodityToEdit: commodityRec,
                    linkProps: linkProps,
                    modelId: this.modelId
                };

                this.showSelectCommodityDialog = true;
                this.commoditySelectedCallback = callback;
            });


        //this.nodeTagEditor = new NodeTagsEditor($("#tokenfield-typeahead"),
        //    this.nodeTagsTypeaheadUrl);



        // Initialize tooltips
        $('[data-toggle="tooltip"]')
            .tooltip({
                'delay': { show: 500, hide: 500 }
            });

        // The following implements no select for the entire page
        // To prevent Ctrl-A selecting everything
        // Because we want it to select nodes in the diagram only
        $("body").addClass("noselect");


        // The paste button is only needed for IE
        if ((window as any).clipboardData == undefined)
            $("#pasteButton").hide();



        // End of document ready

        // Ajax stop handler to unblock the ui
        // Un-blockUI handler used to be here

        //userNotifier.showSimpleMessage("Select a sector in the tree to view diagram");

        //notificationRect = document.getElementById('notificationsDiv').getBoundingClientRect();
        //$('#treeDiv').css("height", HEIGHT);
        //$('#diagramDiv').css("height", HEIGHT);

        // Restore selected group external nodes for convenience
        var groupExternalNodes = localStorage.getItem("modelDiagram_groupExternalNodes") === "1";
        $("#groupExternalNodesCheckbox").prop("checked", groupExternalNodes);


        // Tab control change event
        $('a[data-toggle="tab"]')
            .on("shown.bs.tab",
                (e => {
                    var target = $(e.target).parent().attr("id"); // activated tab
                    this.viewTabChanged(target);
                }));


        // Try to clear dialogs when closed
        // Not sure if this is needed or even works
        //$('body')
        //    .on('hidden.bs.modal',
        //        '.modal',
        //        function() {

        //            // Make sure the handsontable is destroyed so copy/paste is restored
        //            // to the diagram
        //            var table = $('#tableDiv').handsontable('getInstance');
        //            if (table)
        //                table.destroy();
        //            $(this).removeData('bs.modal');
        //        });



        // Handler for link data dialog hide
        // Try and get rid of it
        $("#linkDataModalDiv")
            .on("hidden.bs.modal",
                () => {
                    //$(this).data('bs.modal', null);

                    // Stop re-entry
                    $("#linkDataModalDiv").off("shown.bs.modal");

                    // Get rid of the table (not needed I think)
                    // var hot = $('#linkDataTableDiv').handsontable('getInstance');
                    // hot.destroy();

                });

        // Layout for node charts
        this.nodeChartsLayouter = new VueGridLayouter(this.nodeChartsCellObjects,
            (val) => `node-charts-cell-${val}`,
            3,
            9);

        // Layout for node tables
        this.nodeTablesLayouter = new VueGridLayouter(this.nodeTablesCellObjects, (val) => `node-tables-cell-${val}`,
            3, 9);

        // Layout for node tables
        this.nodeMapsLayouter = new VueGridLayouter(this.nodeMapsCellObjects, (val) => `node-maps-cell-${val}`,
            3, 9);

        // Layout for i/o views
        // Layout for node tables
        this.nodeIoViewsLayouter = new VueGridLayouter(this.nodeIoViewsCellObjects, (val) => `node-ui-view-cell-${val}`,
            3, 9);

        this.setControlSizes();


        const snapNodesToGrid = localStorage.getItem("modelDiagram_snapNodesToGrid");
        if (snapNodesToGrid)
            this.diagramOptions.snapNodesToGrid = snapNodesToGrid === "true";

        const snapGridSize = localStorage.getItem("modelDiagram_snapGridSize");
        if (snapGridSize)
            this.diagramOptions.snapGridSize = this.forceNumberFromString(snapGridSize);

        const autoCreateKinkPoints = localStorage.getItem("modelDiagram_autoCreateKinkPoints");
        if (autoCreateKinkPoints)
            this.diagramOptions.autoCreateKinkPoints = autoCreateKinkPoints === "true";

        if (!this.modelId) {
            bootbox.alert("No model selected.  You will now be redirected to the model index page",
                () => {
                    this.$router.push({ name: "model-directory" });

                });
        }
        else

            this.loadModel();


        // This is called if the model is modified somewhere else, e.g. by an AI action
        this.$store.subscribeAction(async (action, state) => {
            if (action.type === "profile/setNodeModifiedNotification" && action.payload) {
                if (this.modelTree) {
                    const activeNode = this.modelTree.getActiveNode();
                    if (activeNode && activeNode.pathAndName === action.payload) {

                        await this.refreshDiagramAsync();
                        this.modelTree.refreshNodeChildren(action.payload);
                    }
                }
            }
        });
    }

    created() {

        GlobalEventEmitter.$on('modelCommandEvent', (modelId: string, event: IBasicCommandResponse) =>
            this.refreshUndoRedo(modelId));
    }

    beforeDestroy() {
        GlobalEventEmitter.$off('modelCommandEvent');
    }

    changeView(viewType: IViewType) {
        this.rootNode = viewType.rootNode;
        this.populateTree();
    }

    refreshSpreadsheet() {
        const activeNode = this.modelTree.getActiveNode();
        this.doRefreshNodeSpreadsheet(activeNode.pathAndName);

    }

    downloadSelectedViewsClick() {
        const activeTab = $(".viewTabLi.active");
        const viewParentId = activeTab.attr("data-view-parent-id");

        let nodePaths = [this.modelTree.getActiveNode().pathAndName];
        if ((activeTab.attr("id") === "inputOutputDiagramTabLi")) {
            nodePaths = this.ioDiagramSelectedNodes.map(node => node.pathAndName);
        }

        this.downloadSelectedViews(viewParentId, nodePaths);

    }

    copyButtonClick() {
        // Kind of have to guess if we are diagram copying or tree copying
        if (this.diagram && this.diagram.copyDiagramSelection())
            return true;
        else {
            this.modelTree.copySelectedTreeNodes(
                false);
            return false;
        }

    }

    centerDiagramClick() {
        const activeTab = $(".viewTabLi.active").attr("id");
        if (activeTab === "diagramTabLi" && this.diagram)
            this.diagram.centerDiagram(true);
        else
            if (activeTab === "inputOutputDiagramTabLi" && this.ioDiagram)
                this.ioDiagram.centerDiagram(true);

    }

    zoomInClick() {
        if (this.diagram)
            this.diagram.zoomIn();
    }

    zoomOutClick() {
        if (this.diagram)
            this.diagram.zoomOut();
    }

    pasteButtonClick() {
        /* IE only fucking bs to fix non-pasting to tree problem */
        const clipboarddata = (window as any).clipboardData.getData("Text");
        this.pasteNodesFromClipboard(clipboarddata);

    }


    // IO diagram refresher
    async getIODiagramData(sectorPathAndName): Promise<NetworkDiagramBuilder> {
        //d3.select("svg").remove();

        d3.selectAll("#ioDiagramSVG > *").remove();

        this.modelServices.getNetworkDiagram(this.modelId,
            sectorPathAndName,
            "InputOutput",
            $("#groupExternalNodesCheckbox").is(":checked")) // groupExternalNodesBySector
            .then(async result => {
                this.ioDiagramState.setState(450, 300, result.state.scale);
                var nodes: IOldNodeIcon[] = result.nodes;
                var links = result.links;

                var nodeDefs = new NodeDefs();

                var selectionChangedHandler = (selectedNode) => {
                    if (selectedNode) {
                        this.doRefreshNodeIOViews(selectedNode.pathAndName, "", $("#ioViewList"), "#ioViewList");
                        this.ioDiagramSelectedNodes = [selectedNode];
                    } else this.ioDiagramSelectedNodes = null;

                }

                // Setup ioDiagramSelectedNodes so download charts button works now
                this.ioDiagramSelectedNodes = [{ pathAndName: sectorPathAndName }];

                this.diagramBuilder = new NetworkDiagramBuilder(
                    this.getDimensionsFunc,
                    this.modelValidation,
                    this.editNodeDataFunc,
                    this.nodeHyperlinkClickHandler,
                    //diagramClipboard,
                    this.showLinkDataFunc,
                    nodeDefs,
                    this.commoditySelector,
                    $("#ioDiagramDiv"),
                    this.modelActionsHandler,
                    selectionChangedHandler
                );

                //new AH.MB.NetworkDiagram.Drawer();
                //networkDiagram;

                if (result.hasDiagram) {
                    this.ioDiagram = await this.diagramBuilder.buildDiagram(
                        links,
                        nodes,
                        sectorPathAndName,
                        "",
                        this.linkingNode,
                        this.ioDiagramState,
                        false,
                        false,
                        "#ioDiagramSVG",
                        "io_",
                        {
                            showPalette: false,
                            centerDiagram: false,
                            snapNodesToGrid: this.diagramOptions.snapNodesToGrid,
                            snapGridSize: this.diagramOptions.snapGridSize,
                            autoCreateKinkPoints: this.diagramOptions.autoCreateKinkPoints,
                            alwaysShowKinkPoints: true,
                            forceSimulationConfig: DiagramForceSimulationConfig.Default,
                            applyKinkPointsToLinks: false
                        }
                    );

                    // Attach diagram to model event observer
                    this.modelObserver.attach(this.diagramBuilder);

                    this.ioDiagram.centerDiagram(true);

                    // Show IO views for the focused node in the diagram
                    this.doRefreshNodeIOViews(sectorPathAndName, "", $("#ioViewList"), "#ioViewList");

                }

                return this.ioDiagram;

                //callbackFunc(this.diagram, nodes);

            });

        return this.ioDiagram;
    }

    selectAllViews() {
        const activeTab = $(".viewTabLi.active");
        const viewParentId = activeTab.attr("data-view-parent-id");
        ViewManager.toggleViewsSelected($(viewParentId));
    }

    getDimensionsFunc(selectorStr) {
        var width = $(selectorStr).width();
        var height = $(selectorStr).height();
        return { width, height };
    };


    // Function to get diagram for a given sector
    getDiagramDataAsync(sectorPathAndName,
        buildConfig: NetworkDiagramConfig): Promise<NetworkDiagramBuilder>
    //    nodes: INodeObject[]) => void) 
    {

        return this.modelServices.getNetworkDiagram(this.modelId,
            sectorPathAndName,
            "Sector",
            $("#groupExternalNodesCheckbox").is(":checked")) // groupExternalNodesBySector
            .then(async result => {
                this.diagramState.setState(result.state.xPos, result.state.yPos, result.state.scale);
                var nodes = result.nodes;
                var links = result.links;

                var showPaletteNodeCaptions = this.getShowPaletteNodeCaptions();

                var tempNodeToFocus = this.nodeToFocusInDiagram;
                this.nodeToFocusInDiagram = null;

                // Todo: replace with commodity selector dialog
                //var commoditySelector = new AH.MB.UI.CommoditySelector(function() { return this.modelId; });

                var nodeDefs = new NodeDefs();

                // If we are reloading, we will have to
                // detatch the observer from the previous diagram
                if (this.diagramBuilder) {
                    this.modelObserver.detatch(this.diagramBuilder);

                    // And clear the old nodes
                    this.diagramBuilder.clear({ removePalette: false });

                }

                // Setup height and width

                this.diagramBuilder = new NetworkDiagramBuilder(
                    this.getDimensionsFunc,
                    this.modelValidation,
                    this.editNodeDataFunc,
                    this.nodeHyperlinkClickHandler,
                    //diagramClipboard,
                    this.showLinkDataFunc,
                    nodeDefs,
                    this.commoditySelector,
                    $("#diagramDiv"),
                    this.modelActionsHandler,
                    this.diagramNodeSelectionChangeHandler
                );

                //new AH.MB.NetworkDiagram.Drawer();
                //networkDiagram;


                //if (result.hasDiagram) 
                {
                    this.diagram = await this.diagramBuilder.buildDiagram(
                        links,
                        nodes,
                        sectorPathAndName,
                        tempNodeToFocus,
                        this.linkingNode,
                        this.diagramState,
                        showPaletteNodeCaptions,
                        true,
                        "#diagramSVG",
                        "",
                        buildConfig
                    );

                    // Attach diagram to model event observer
                    this.modelObserver.attach(this.diagramBuilder);

                    // Save selected sector to local storage for convenience
                    // Only do it if diagram has nodes or it triggers for root node on model load
                    if (nodes.length > 0)
                        localStorage.setItem(`modelTree_ActiveNode_${this.modelId}`, sectorPathAndName);

                    // Save selected group external nodes for convenience
                    localStorage.setItem("modelDiagram_groupExternalNodes",
                        $("#groupExternalNodesCheckbox").is(":checked") ? "1" : "0");
                }

                //                return this.diagram;

                //                callbackFunc(this.diagram, nodes);

                return this.diagram;

            });

    }

    // Populate tree function
    populateTree() {

        const getNodesUrlFunc = (modelId: string, nodePathAndName: string) => {

            nodePathAndName = encodeURIComponent(nodePathAndName);

            var treeUrl =
                `/api/1.0/modeltree?modelId=${modelId}&rootNode=${nodePathAndName}&lazy=${this.modelTreeIsLazy}&filter=${this.modelTreeFilter}`;

            treeUrl = encodeURI(treeUrl);
            return treeUrl;
        };

        if (!this.rootNode)
            this.rootNode = "\\Root";


        const params = { modelId: this.modelId, nodePathAndName: this.rootNode } as any;
        const paramString = new URLSearchParams(params);
        const url = `/api/1.0/nodes/getnode?${paramString.toString()}`;

        FetchWrapper.fetch(url, { method: "get" })
            .then(response => response.json())
            .then(node => {

                // Create a root tree node
                const rootTreeNode = {
                    title: node.name,
                    key: node.nodePathAndName,
                    lazy: true,
                    extraClasses: "root-node fancytree-has-children",
                    folder: true,
                    nodeType: node.nodeTypeName
                };


                if (this.modelTree) {

                    // Save current node in tree in case we come back to it
                    this.modelTree.reload(this.modelId, rootTreeNode).then(() => {
                        if (this.currentViewType.lastVisitedTreeNode && !this.modelTreeFilter)
                            this.nodeHyperlinkClickHandler(this.currentViewType.lastVisitedTreeNode, true);

                    });
                } else {
                    this.modelTree = new ModelTree(
                        $("#treeDiv"),
                        getNodesUrlFunc,
                        this.modelId,
                        rootTreeNode,
                        this.treeSelectionChanged,
                        this.modelActionsHandler,
                        this.treeNodeIconClicked,
                        this.modelValidation,
                        this.treeIconDeactivated);
                }
                this.modelObserver.attach(this.modelTree);

                this.modelTree.expandRootNode()
                    .then(() => {

                        if (this.modelTreeFilter) {
                            const rootNode = this.modelTree.tree.getActiveNode();
                            rootNode.setTitle(`Search results for ${this.modelTreeFilter} (${this.modelTree.tree.getActiveNode().children.length} nodes)`);
                            rootNode.removeClass("root-node");
                            rootNode.addClass("search-results-node");

                        }
                        else {
                            var nodeToJumpTo = this.targetSector;

                            // Get target sector if any, passed in from model validation link for example
                            if (!nodeToJumpTo) {
                                // Goto the previous selected sector for the model, if there is one
                                // It is loaded from localstorage
                                nodeToJumpTo = localStorage.getItem(`modelTree_ActiveNode_${this.modelId}`);
                            }
                            if (nodeToJumpTo)
                                this.nodeHyperlinkClickHandler(nodeToJumpTo, true);
                        }
                        //this.targetSector = "";}
                    });
            });
    }

    // Tree node icon click event
    treeNodeIconClicked(nodeObject) {

        // Show editor for leaf nodes only
        if (["Sector", "Root", "Model"].indexOf(nodeObject.nodeType) === -1) {
            this.editNodeDataFunc(nodeObject.pathAndName);

            // Return continueProcessing as false to prevent further processing
            return false;
        }
        return true;
    }

    // Loads a diagram
    showDiagramAsync(nodePath: string, buildConfig: NetworkDiagramConfig): Promise<NetworkDiagramBuilder> {
        // Set header label text
        let headerText = this.modelId;
        if (nodePath) {
            headerText = headerText + ": " + nodePath; //.data.title;
            this.navStack.add(nodePath);
        } else
            headerText = headerText + ": (no sector selected)";

        // Show path in title
        var $link = $("#pageHeader");
        const $img = $link.find("img");
        $link.html(headerText + " ");
        $link.append($img);

        // Show busy indicator
        this.showBusy();

        // Load the diagram
        return this.getDiagramDataAsync(
            nodePath,
            buildConfig)
            .then(newDiagram =>
            //            (newDiagram, theNodes) => 
            {
                this.hideBusy();

                //if (theNodes)
                // Using the nodes we can show the nodecount in the header
                //$link.append(` <small>${theNodes.length.toString()} nodes</small>`);

                //return Promise.resolve({ newDiagram, theNodes });
                //                callback(newDiagram, theNodes);
                return newDiagram;
            })

        //.then(diagram)

        //        return Promise.reject();

    }

    saveDiagramState(nodePathAndName: string) {
        if (this.diagramState.isValid())

            this.modelServices.saveDiagramState(this.modelId,
                nodePathAndName,
                this.diagramState.xPos,
                this.diagramState.yPos,
                this.diagramState.scale);
    }

    treeIconDeactivated(node: NodeObject): boolean {

        if (this.diagram && this.diagram.nodes && this.diagram.nodes.length > 0) {

            // The active node may not be a sector
            let nodePath = node.pathAndName;
            if (node.nodeType !== "Sector")
                nodePath = NodeObject.extractPath(nodePath);
            this.saveDiagramState(nodePath);
        }
        return true;
    }


    @Watch("tag")
    tagChanged() {

        if (this.tag.length < 2) return;
        const url = `/api/1.0/nodetags/suggestions?modelId=${this.modelId}&searchterm=${this.tag}`;

        clearTimeout(this.tagAutoCompleteDebounce);
        this.tagAutoCompleteDebounce = setTimeout(() => {
            FetchWrapper.fetch(url, { method: "get" })
                .then(response => response.json())
                .then((response: Array<string>) => {
                    this.nodeTagAutocompleteItems = response.map(a => {
                        return { text: a };
                    });
                });
        }, 600);
    }

    onNodeTagsChanged(tags: Array<ITagObject>) {

        if (this.selectedNodes.length > 0) {
            const node = this.selectedNodes[0];
            const payload = {
                modelId: this.modelId,
                nodePathAndName: node.pathAndName,
                tags: tags.map(p => p.text)
            };

            var busyNotification = this.userNotifier.showBusyNotification("Applying tags...")
            FetchWrapper.sendCommandAndHandle(
                "/api/1.0/nodetags",
                { method: "post", body: JSON.stringify(payload) })
                .then(() => this.userNotifier.clear(busyNotification));
        }

    }

    showNodeTags(node: NodeObject) {


        if (node) {

            // Causes flicker
            // $('#tokenfield-typeahead-tokenfield').attr("placeholder", node.name + " tags");
            //$('#tokenfield-typeahead-tokenfield').attr("placeholder", node.name + " tags");

            FetchWrapper.fetch(`/api/1.0/nodetags/tags?modelId=${this.modelId}&nodePathAndName=${node.pathAndName}`,
                { method: "get" })
                .then(response => response.json())
                .then((data: Array<string>) => {
                    this.tags = data.map(p => {
                        return { text: p }
                    }); //.showNodeTags(
                    //data,
                    //nodeTagsChangedEvent);
                });
        } else
            this.tags = []; //nodeTagEditor.clear();
    }

    getNodeTagsAutoCompleteItems() {


    }

    updateGroupControlsEnabled(node) {
        // Node can be single, or array
        // Normalize to an array if it isn't


        const canGroup = node.length > 1;
        const canUngroup = !canGroup &&
            node.length === 1 &&
            node[0].nodeType === "GroupNode" &&
            !NodeObject.isShadowNodeName(node[0].name);

        if (canGroup) {

            $("#groupNodesBtn").removeAttr("disabled");
            $("#ungroupNodesBtn").attr("disabled");
        } else {
            $("#groupNodesBtn").attr("disabled");
            $("#ungroupNodesBtn").removeAttr("disabled");

        }

    }

    diagramNodeSelectionChangeHandler(node) {

        this.showNodeTags(node);

        if (!node)
            node = [];
        else
            // May not be array - normalize for the following
            if (node.constructor !== Array)
                node = [node];

        this.updateGroupControlsEnabled(node);

        // Assign to global selected nodes variable
        this.selectedNodes = node;

    }


    // Handler for tree selection change
    async treeSelectionChanged(nodes) {

        // Assign to global selected nodes variable
        // Annoyingly, nodes only includes node clicked, not all nodes selected
        const allNodes = this.modelTree ? this.modelTree.getSelectedNodes() : [];
        this.selectedNodes = allNodes;

        // Update node tags
        if (nodes.length === 1) {
            this.showNodeTags(nodes[0]);
        } else
            this.tags = [];

        if (nodes.length < 1 || nodes.length > 2) {
            this.setCurrentNodePath("");
            return;
        }

        this.updateGroupControlsEnabled(allNodes);

        var node = nodes[0];


        // Get the full selected node path and name
        var nodePath = node.pathAndName;

        // A DynaTreeNode object is passed to the activation handler
        // Note: we also get this event, if persistence is on, and the page is reloaded.

        // Refresh charts, if chart tab is active

        const activeTab = $(".viewTabLi.active").attr("id");
        this.viewTabChanged(activeTab);

        //if ($('#chartTabLi').hasClass("active"))
        //    doRefreshNodeViews(nodePath);

        // Check for records export definition node, under root 
        if (node.nodeType === 'RecordsExportDefinition') {
            this.showPublishToDashboardDialog = true;

            this.publishToDashboardModel = {
                nodePathAndName: node.pathAndName,
                modelId: this.modelId,
            }

            return;
        }
        else {
            //this.activeRecordsExportDefinitionNode = "";
            this.showPublishToDashboardDialog = false;
            this.publishToDashboardModel = {
                nodePathAndName: "",
                modelId: "",
            }

        }

        // If a sector, we want to go to that sector (unless it's a group node)
        if (node.isFolder) {

            this.currentViewType.lastVisitedTreeNode = nodePath;

            //$("#diagramHeader").text(headerText);

            // Load diagram data, in callback hide busy indicator

            await this.showDiagramAsync(nodePath, this.getDiagramOptions())
                .then(() => this.updateModelTreeActions(nodePath, node.nodeType));

        } else {
            // Not a sector
            // Note: this gets triggered on page load, so verify diagram is instantiated
            if (this.diagram) {

                // If we are in the same diagram as the leaf node:
                if (this.navStack.topName() === node.path) {
                    this.diagram.showNode(node.name);
                } else {
                    // Need to move to another sector
                    this.nodeHyperlinkClickHandler(node.pathAndName, true);

                }

            } else {

                // An activity in an unloaded diagram - load diagram, show node
                await this.showDiagramAsync(node.path,
                    this.getDiagramOptions(false, false))
                    .then(diagramBuilder => {
                        diagramBuilder.showNode(node.name);
                        this.updateModelTreeActions(node.path, node.nodeType);
                    });
            };
        }

        // Update global state with the selected node
        this.setCurrentNodePath(nodePath)
    }


    // Document paste handler
    documentPasteHandler(e) {

        const text = (e.originalEvent || e).clipboardData.getData("text/plain");
        if (!text) {
            alert("Error getting clipboard data");
            return;
        }

        let isNodes = false;

        // Check if this is nodes, if so we want to paste nodes from clipboard
        // and prevent further processing
        try {
            const clipboardData = JSON.parse(text);
            if (clipboardData.sourceModelId != undefined)
                isNodes = true;

        } catch (e) {
            isNodes = false;
        }

        if (isNodes) {
            e.preventDefault();
            this.pasteNodesFromClipboard(text);

        }
    }

    async pasteNodesFromClipboard(clipboardText) {

        const targetNode = this.modelTree.getActiveNode();

        if (targetNode) {

            // I a leaf node is selected, paste to it's parent
            var targetPath =
                (targetNode.isFolder)
                    ? targetNode.pathAndName
                    : targetNode.path;

            this.modelActionsHandler.pasteNodesFromClipboard(targetPath, clipboardText, [])
                .then(async data => {
                    if (data.success && this.diagram) {
                        // Just reload the diagram rather than try and rebuild it
                        // To highlight new ones, get the old list then
                        // compare it to the new diagram and get the delta
                        // which will be highlighted
                        // so they can be dragged
                        var existingIcons = this.diagram.nodes;
                        await this.showDiagramAsync(targetPath, this.getDiagramOptions())
                            .then(newDiagram => {
                                var iconDelta = newDiagram.nodes.filter((curIcon) => {

                                    var found = false;
                                    existingIcons.some((curNode) => {
                                        if (curIcon.pathAndName === curNode.pathAndName) {
                                            found = true;
                                            return true;
                                        } else
                                            return false;
                                    });
                                    return !found;
                                });

                                var deltaPaths = iconDelta.map((icon) => { return icon.pathAndName; });
                                newDiagram.highlightNodes(deltaPaths);
                            });
                    }
                });
        } else
            bootbox.alert("No target tree node selected");
    }

    // Add sector button click handler
    addSectorButtonClick() {
        var parentNode = this.modelTree.getActiveNode();
        if (parentNode.nodeType === "Root") {
            // If a model was created, need to show editor for it immediately
            this.showNewModelDialog(parentNode, parentNode.pathAndName);
        } else {
            bootbox.prompt({
                title: `Create node under ${parentNode.pathAndName}`,
                content: "",
                callback: (nodeName) => {
                    if (nodeName)
                        this.modelActionsHandler.createNode(parentNode.pathAndName, nodeName, this.currentViewType.sectorNodeType, null);

                }
            });
        };
    }

    // Rename sector button click handler
    renameSectorButtonClick() {
        const activeNode = this.modelTree.getActiveNode();
        if (activeNode)
            this.modelActionsHandler.renameNode(activeNode.pathAndName);
    }

    groupNodesButtonClick() {
        var nodes = this.selectedNodes; //   diagram.getSelectedNodes();

        bootbox.prompt({
            title: `Name of group (${nodes.length.toString()} nodes)`,
            callback:
                (value) => {
                    if (value) {
                        this.modelActionsHandler.groupNodes(nodes, value);
                    }
                }
        });

    }

    ungroupNodesButtonClick() {

        const nodes = this.selectedNodes; //   diagram.getSelectedNodes();
        var nodeToUngroup = nodes[0].pathAndName;

        bootbox.confirm(`Ungroup ${nodeToUngroup}?`,
            ok => {
                if (ok) {
                    //var nodes = diagram.getSelectedNodes();
                    this.modelActionsHandler.ungroupNodes(nodeToUngroup)
                        .then(async (response) => {

                            // Do not try and manually rebuild the diagram - too complex
                            // Just reload it

                            //if (this.modelTree) {
                            //    var activeTreeNode = this.modelTree.getActiveNode();
                            //    if (activeTreeNode && activeTreeNode.pathAndName === nodeToUngroup)

                            //}

                            await this.refreshDiagramAsync();

                        });
                }
            });

    }

    // Delete all attachments handler
    doDeleteAllAttachments() {
        bootbox.confirm(`Delete  all attachments?`,
            (ok: boolean) => {
                if (ok) {

                    FetchWrapper.sendCommandAndHandle("/api/1.0/attachments/delete",
                        {
                            method: "post",
                            body: JSON.stringify({
                                modelId: this.modelId,
                                attachmentIds: []
                            })
                        })
                        .then((data) => {
                            this.doRefreshAttachments();
                        });
                }

            }
        );
    }

    // Delete sector button click handler
    deleteNodeButtonClick() {

        var nodes = this.modelTree.getSelectedNodes();

        switch (nodes.length) {
            case 0:
                bootbox.alert("No nodes selected");
                return;
            case 1:
                bootbox.confirm(`Delete ${nodes[0].name}?`,
                    result => {
                        if (result)
                            this.modelServices.deleteNodes(this.modelId, nodes);
                    });
                break;

            default:
                bootbox.confirm(`Delete ${nodes.length.toString()} nodes?`,
                    result => {
                        if (result)
                            this.modelServices.deleteNodes(this.modelId, nodes);
                    });
                break;
        }

    }

    // Scrolls to top
    scrollTreeeToTopButtonClick() {
        this.modelTree.scrollToTop();
    }

    private editNodeDataFunc(nodePathAndName: string) {
        this.showEditNodeDataDialog = true;
        this.editNodeDataModel = { modelId: this.modelId, nodePathAndName: nodePathAndName };
    }

    showEditNodeDataDialogClosed() {

        this.showEditNodeDataDialog = false;
    }

    sectorPropertiesButtonClick() {
        const activeNode = this.modelTree.getActiveNode();
        if (activeNode)
            this.editNodeDataFunc(activeNode.pathAndName);
    }

    // Loads all tree nodes, if it is lazy
    loadAllTreeNodes(callback) {

        // For this to work all nodes must be present
        if (this.modelTreeIsLazy) {
            this.modelTreeIsLazy = false;
            const nodePathAndName = "\\Root";
            let url = `/api/1.0/modeltree?modelId=${this.modelId}&rootNode=${nodePathAndName}&lazy=${this.modelTreeIsLazy}`;
            url = encodeURI(url);

            var notification = this.userNotifier.showNotification("Loading model tree...", true, true);

            $.get({
                url: url,
                global: false,
                success: (data) => {
                    this.modelTree.setChildNodes("\\Root", data);

                    // Get the filter text now, because user may have continued typing
                    // while it was loading
                    this.userNotifier.clear(notification);
                    callback();

                }
            });
        } else
            callback();
    }

    // Tree filter edit key up
    treeFilterInputBoxEditKeyUp(e) {

        MethodDelayer.delayMethod(
            "treeFilter",
            () => {

                const searchInput = $("#treeFilterInputBox").val();
                if (StringUtils.isText(searchInput)) {
                    this.modelTreeFilter = searchInput;
                    this.populateTree();
                }
                //    this.loadAllTreeNodes(() => {
                //        var innerFilter = $("#treeFilterInputBox").val();
                //        this.modelTree.applyFilter(innerFilter as string);

                //    });
            });
    }


    searchAndReplaceButtonClick() {

        this.searchAndReplaceSettings = {
            modelId: this.modelId,
            rootNode: this.modelTree.getActiveNode().pathAndName,
            searchText: "",
            replaceText: "",
            targetType: "Node names"

        }
        this.showSearchAndReplaceDialog = true;

    }

    searchAndReplaceDialogClosed(dialogResult: string): Promise<NetworkDiagramBuilder> {
        this.showSearchAndReplaceDialog = false;
        if (dialogResult === "ok") {
            this.modelTree.refreshNodeChildren(this.searchAndReplaceSettings.rootNode);
            return this.refreshDiagramAsync();
        }
        return Promise.reject();

    }

    // Tree back button click
    treeBackButtonClick() {
        if (this.navStack.canGoBack()) {
            this.navStack.beginUpdate();
            const target = this.navStack.back();
            this.nodeHyperlinkClickHandler(target, false);
            this.navStack.endUpdate();
        }
    }

    // Tree forward button click
    treeForwardButtonClick() {
        if (this.navStack.canGoForward()) {
            this.navStack.beginUpdate();
            const target = this.navStack.forward();
            this.nodeHyperlinkClickHandler(target, false);
            this.navStack.endUpdate();
        }
    }

    // Show link data click handler
    showLinkDataFunc(srcNodePathAndName, destNodePathAndName) {
        this.linkDataModel = {
            modelId: this.modelId,
            sourceNodePathAndName: srcNodePathAndName,
            destNodePathAndName: destNodePathAndName
        };
        this.showLinkDataDialog = true;
    };

    linkDataDialogClosed() {
        this.showLinkDataDialog = false;
    }

    // Node hyperlink(shadow) click - move to target
    // Note: can fail if not not found, e.g. if tree is lazy
    async nodeHyperlinkClickHandler(nodePath, gotoParent: boolean) {

        //if (this.modelTreeFilter) {
        //    this.modelTreeFilter = "";
        //    this.populateTree();
        //}

        if (this.modelTree.findNode(nodePath) === null) {
            // Node not found: if lazy, load tree again, then recurse
            if (this.modelTreeIsLazy) {
                // Do this smart by loading each part of the path selectively
                // Instead of loadAllTreeNodes

                this.modelTree.expandToNode(nodePath)
                    .then(() => {
                        // Prevent recursion here...
                        if (this.modelTree.findNode(nodePath) === null) {

                            //    bootbox.alert("Node not found", function () { });
                        } else
                            this.nodeHyperlinkClickHandler(nodePath, gotoParent);

                    })
                    .catch(() => {
                        //bootbox.alert("Node not found", function() {});
                    });


            }

            // bootbox.alert("Node not found", function() {});

        } else {

            const activeTreeNode = this.modelTree.getActiveNode();
            if (!activeTreeNode || activeTreeNode.pathAndName !== nodePath) {
                // This happens when loading directly a node e.g. from node validation results
                // Activating the node will cuase the diagram to load so that is all we need to do
                this.modelTree.activateNode(nodePath, false);
            } else {
                // The user has selected the node in the tree, so we have to show it
                const parentPath = this.modelValidation.extractPath(nodePath);
                var nodeName = ModelUtils.extractName(nodePath);

                // A leaf node, so show the parent diagram, then focus
                // the leaf node in the callback
                await this.showDiagramAsync(parentPath, this.getDiagramOptions())
                    .then(diagramBuilder => {
                        diagramBuilder.showNode(nodeName);

                    }); //.done(alert("Focus here.."));
            }
            //            modelTree.activateNode(nodePath, gotoParent)
            //              .done(function() {
            //                if (gotoParent) {

            // Have to get the path from the name
            //                    var lastDelim = nodePath.lastIndexOf('\\');
            //                   nodeToFocusInDiagram = nodePath.substr(lastDelim + 1);
            //                  if (diagram)
            //                     diagram.showNode(nodeToFocusInDiagram);
            //            }


            //      });
        }
    }


    // Update model tree actions function - triggered by sector select
    updateModelTreeActions(path: string, nodeType: string) {
        // Null check
        if (!nodeType) {
            $("#deleteSectorButton").addClass("disabled");
            $("#addSectorButton").addClass("disabled");
            $("#renameSectorButton").addClass("disabled");
            $("#sectorPropertiesButton").addClass("disabled");

        } else {

            var canDelete = this.modelValidation.canDeleteNode(nodeType, false);
            if (canDelete.ok)
                $("#deleteSectorButton").removeClass("disabled");
            else
                $("#deleteSectorButton").addClass("disabled");

            var eligibleChild = this.modelValidation.eligibleChildNodeType(nodeType);
            if (eligibleChild === "")
                $("#addSectorButton").addClass("disabled");
            else {

                if (nodeType === "Root")
                    $("#addSectorButton").text("Add Model");
                else
                    $("#addSectorButton").text("Add Sector");

                $("#addSectorButton").removeClass("disabled");

                //$('#addSectorButton').text('Add'); // Disabled because it makes button too long:  + eligibleChild);
            }
        }

        // Enable/disable rename button
        var canRename = this.modelValidation.canRename(nodeType, false);
        if (canRename.ok)
            $("#renameSectorButton").removeClass("disabled");
        else
            $("#renameSectorButton").addClass("disabled");

        // Enable export button once a node is selected
        if (nodeType) {
            $("#exportDataButton").removeClass("disabled");
            $("#centerDiagramButton").removeClass("disabled");
            $("#zoomInButton").removeClass("disabled");
            $("#zoomOutButton").removeClass("disabled");
        } else {
            $("#exportDataButton").addClass("disabled");
            $("#centerDiagramButton").addClass("disabled");
            $("#zoomInButton").addClass("disabled");
            $("#zoomOutButton").addClass("disabled");
        }

        $("#copyButton").toggleClass("disabled", !nodeType);
        $("#pasteButton").toggleClass("disabled", !nodeType);
        $("#goToNodeButton").toggleClass("disabled", !nodeType);

        // Enable edit sector properties button
        $("#sectorPropertiesButton").removeClass("disabled");

        // Scroll to top button enable/disable (always enabled)
        // $('#scrollTreeeToTopButton').toggleClass('disabled', !nodeType);

        // Search and replace button enabled/disabled
        $("#searchAndReplaceButton").toggleClass("disabled", !nodeType);

        // Enable/disable nav buttons
        $("#treeBackButton").toggleClass("disabled", !this.navStack.canGoBack());
        $("#treeBackButton").attr("title", `Back to ${this.navStack.backName()}`);
        $("#treeForwardButton").toggleClass("disabled", !this.navStack.canGoForward());
        $("#treeForwardButton").attr("title", `Forward to ${this.navStack.forwardName()}`);
    };

    newModalNodeDialogAccepted(value: ICreateModelNodeModel) {
        this.showCreateModelNodeDialog = false;

        var initData = {
            NumTimePoints: value.numTimePoints,
            StartTimePoint: value.startTimePoint,
            NumSubTimePoints: value.numSubTimes,
            NumStates: value.numStates
        }

        this.modelActionsHandler.createNode("\\Root", value.nodeName, "Model", initData);

    }

    newModalNodeDialogCanceled() {
        this.showCreateModelNodeDialog = false;

    }

    // New model function
    showNewModelDialog(parentNode, parentPath) {

        const currentYear = new Date().getFullYear();
        this.createModelNodeModel =
            { modelId: this.modelId, nodeName: "", numTimePoints: 10, numSubTimes: 1, numStates: 1, startTimePoint: currentYear };
        this.showCreateModelNodeDialog = true;

    };

    // Export data button click handler
    exportDataButtonClick() {

        const node = this.modelTree.getActiveNode();
        if (node) {

            this.exportNodeDataModel = {
                modelId: this.modelId,
                nodePathAndName: node.pathAndName,
                includeSubRegions: true,
                excludeTags: [],
                tags: [],
                tagsAndOr: "and",
                variableNames: [],
                nodeTypes: []

            };
            this.showExportNodeDataDialog = true;
        };
    }

    exportNodeDataDialogClosed() {
        this.showExportNodeDataDialog = false;
    }


    viewReportsCarouselButtonClick() {
        const activeNode = this.modelTree.getActiveNode();

        var activeTab = $(".viewTabLi.active").attr("id");
        var reportTypeFilter: "All" | "Maps" = activeTab == "chartTabLi" ? "All" : "Maps";

        this.modelServices.getNodeCommodities(this.modelId, activeNode.pathAndName)
            .then(result => {
                this.reportCarouselConfig = {
                    modelId: this.modelId,
                    reportTypeFilter: reportTypeFilter,
                    initialViewName: "",
                    subject: activeNode.pathAndName,
                    nodeCommodities: result

                }
                this.showReportCarousel = true;

            });

    }

    importDataButtonClick() {
        this.uploadNodeDataInfo = {
            fileName: "",
            modelId: this.modelId
        }

        this.showUploadNodeDataDialog = true;
    }

    onNodeDataUploaded() {
        this.showUploadNodeDataDialog = false;
    }

    onNodeDataUploading() {
        this.showUploadNodeDataDialog = false;

    }

    // Shows busy indicator
    showBusy() {
        const $link = $("#diagramHeader");
        const $img = $link.find("img");
        $img.show();
    };

    // Hides busy indicator
    hideBusy() {
        const $link = $("#diagramHeader");
        const $img = $link.find("img");
        $img.hide();

    };

    // Shows or hides busy, based on parameter
    busyIndicatorFunc(value) {
        if (value)
            this.showBusy();
        else
            this.hideBusy();
    }

    private optArray = [];

    // Node search event - show node in diagram
    searchNode(selectedVal) {
        this.diagram.showNode(selectedVal);
    }

    // Tab change event
    viewTabChanged(target) {

        if (this.modelTree) {
            const node = this.modelTree.getActiveNode();
            const path = node ? node.pathAndName : "";

            // Reset padding for the tab content
            if (target)
                $("#mainTabContent").css("padding", "12px");

            switch (target) {
                case "diagramTabLi":
                    {
                        // Svg doesn't work well with padding, so get rid of it
                        $("#mainTabContent").css("padding", 0);
                        break;


                    }

                case "inputOutputDiagramTabLi":
                    {
                        // Svg doesn't work well with padding, so get rid of it
                        $("#mainTabContent").css("padding", 0);

                        // Load the diagram
                        this.getIODiagramData(path);
                        break;
                    }

                case "chartTabLi":
                    {
                        if (node)
                            this.doRefreshNodeViews(path,
                                "All",
                                "chart",
                                $("#nodeViewList"),
                                "#nodeViewList",
                                this.nodeChartsLayouter);
                        break;
                    }
                case "tablesTabLi":
                    {
                        if (node)
                            this.doRefreshNodeViews(path,
                                "All",
                                "spreadsheet",
                                $("#nodeTablesViewList"),
                                "#nodeTablesViewList",
                                this.nodeTablesLayouter);
                        break;

                    }

                case "mapsTabLi":
                    {
                        if (node)
                            this.doRefreshNodeViews(path,
                                "Maps",
                                "chart",
                                $("#nodeMapsViewList"),
                                "#nodeMapsViewList",
                                this.nodeMapsLayouter);
                        break;

                    }



                case "attachmentsTabLi":
                    {
                        this.doRefreshAttachments();
                        break;
                    }
                case "nodeSpreadsheetTabLi":
                    {
                        this.doRefreshNodeSpreadsheet(path);
                        break;
                    }

                case "nodeVariablesTabLi":
                    {
                        this.doRefreshNodeVariables(path);
                        break;
                    }
                case "nodeHistoryTabLi":
                    {
                        this.doRefreshNodeHistory(path);
                        break;
                    }
                case "commentsTabLi":
                    {
                        this.doRefreshNodeComments(path);
                        break;
                    }
                case "raw-node-editor-tab-li":
                    {
                        this.doRefreshRawNodeEditor(path);
                        break;
                    }

            }
        }
    }


    internalRefreshNodeViews(fullPath,
        viewTypeFilter,
        target,
        targetSelector,
        viewListGetter: (modelId: string, nodesForReport: string[], queryString: string) => Promise<ViewDef[]>,
        viewDimensionsFunc,
        layouter: GridLayouter) {
        // Only one node for now
        const nodes = [fullPath];

        // Try and load the layout for the active node, which will be used by the gridster
        // to re-use the node layout
        // Currently disabled - no customizing of layout allowed
        //var activeNodeType = modelTree.getActiveNode().nodeType;
        //var gridLayout = null; // nodeViewsLayoutPersistence.getItem(activeNodeType);


        // Chart renderer
        const chartRenderer = new GoogleChartRenderer(
            {
                showLegend: false,
                showTitle: true,
                showXAxisTitlesFunc: title => false,
                showYAxisTitlesFunc: title => title !== "Price" && title !== "Quantity",
                backgroundColor: "white"
            }
        );

        // Function to get selected tp and st for view parameters
        var getViewParametersFunc = () => {
            var tp = $("#timepoint-edit").val();
            var st = $("#subtime-edit").val();
            return tp + "|" + st;

        }

        // Chart data getter
        const chartDataGetter = (modelId, nodesForReport, reportName) => {
            return this.reportServices.getReportByNodeResults(modelId,
                nodesForReport,
                reportName,
                getViewParametersFunc());
        };


        // Use google charts for tables as well
        const spreadsheetRenderer = chartRenderer;

        //// Handsontable spreadsheet renderer
        //var spreadsheetRenderer = new AH.MB.UI.HandsontableRenderer(
        //    {
        //        data: [],
        //        copyPaste: true
        //        //colWidths: 10,
        //        //colHeight: 4,
        //        //stretchH: "all"

        //    });

        // View manager
        const viewManager = new ViewManager(viewListGetter,
            layouter,
            chartDataGetter,
            chartRenderer,
            spreadsheetRenderer,
            viewDimensionsFunc,
            this.$nextTick() // to update layout before drawing charts

        );

        // Render them
        viewManager.renderAll(target, this.modelId, nodes, getViewParametersFunc(), viewTypeFilter);

    }

    // Refresh I/O views
    doRefreshNodeIOViews(fullPath, viewTypeFilter, target, targetSelector) {
        // View list getter
        const viewListGetter = (modelId: string, nodesForReport: string[], queryString: string): Promise<ViewDef[]> =>
            this.reportServices.getReportsByNodes(modelId,
                "NodeContext",
                nodesForReport,
                queryString);

        const viewDimensionsFunc = viewData => ({ columns: 4, rows: 2 });

        this.internalRefreshNodeViews(fullPath,
            viewTypeFilter,
            target,
            targetSelector,
            viewListGetter,
            viewDimensionsFunc,
            this.nodeIoViewsLayouter);

    }

    // Refresh node views
    doRefreshNodeViews(fullPath, reportTypeFilter: "All" | "NodeContext" | "Maps", viewTypeFilter: "chart" | "spreadsheet",
        target, targetSelector, layouter: GridLayouter) {

        // View list getter
        const viewListGetter = (modelId: string, nodesForReport: string[], queryString: string): Promise<ViewDef[]> =>
            this.reportServices.getReportsByNodes(modelId,
                reportTypeFilter,
                nodesForReport,
                queryString);


        const viewDimensionsFunc = viewData => {
            switch (viewData.chartOptions.seriesType) {
                case 4:
                    return { columns: 3, rows: 1 } //tables
                default:
                    return { columns: 4, rows: 2 } // charts
            }
        };


        this.internalRefreshNodeViews(fullPath,
            viewTypeFilter,
            target,
            targetSelector,
            viewListGetter,
            viewDimensionsFunc,
            layouter);
    }


    // Upload attachment
    uploadAttachment() {

        this.uploadAttachmentModel = { modelId: this.modelId, fileName: "" };
        this.showUploadAttachmentDialog = true;
    }

    onAttachmentUploaded(result: string) {
        this.showUploadAttachmentDialog = false;
        this.attachmentsTableRenderer.refresh();
    }

    onAttachmentUploading() {
        this.showUploadAttachmentDialog = false;
    }


    private tempNodePath: string;

    // Gay method to use as a callback for history table below
    getNodePath() {
        return this.tempNodePath;
    }


    private historyTable;

    doRefreshNodeHistory(nodePath) {
        this.tempNodePath = nodePath;

        const tableUrl = `/ModelChangeLog/${this.modelId}/asdatatable`;
        //'@Url.Action("IndexAsDataTable", "ModelCommandLog", new {modelId = @ViewBag.ModelId})';
        // Create an inline editor for comments

        if (!this.historyTable) {

            // Because mvc datatables expects variables in the old format we have to set
            // it to specifically use the old variables, because we are using ajax option below
            //$.fn.dataTable.ext.legacy.ajax = true;


            const columnDefs: DataTables.ColumnSettings[] = [
                {
                    title: "Date",
                    data: "dateExecuted",
                    width: "10%",
                    render: (data) => {
                        var dateStr = data;

                        // Date comes in some non standard format because of datatables
                        // MVC thing
                        var date = moment.utc(dateStr).local().format("dddd, MMMM Do h:mm a");
                        return date;
                    }


                },
                {
                    title: "User",
                    data: "executingUser",
                    width: "5%"
                },
                {
                    title: "Change",
                    data: "description",
                    width: "48%"
                }
            ];

            const ajaxSettings: DataTables.AjaxSettings = {
                url: tableUrl, //"<?php echo base_url('data/ajax'); ?>",
                type: "POST",
                global: false, // Suppress global ajax notification
                data: (data: any) => {
                    data.nodePath = this.getNodePath();
                    return data;
                }
            };

            const tableSettings: DataTables.Settings = {
                //"processing": true,
                serverSide: true,
                //            "sAjaxSource": tableUrl,
                //           "sServerMethod": "POST",
                autoWidth: false,
                paging: true,
                lengthChange: false,
                //                displayLength: 10, Todo: Resolve
                pageLength: 8,
                // fltering: true, Todo: Resolve
                //"stateSave": true,
                order: [[0, "desc"]],
                //sort: true, Todo: Resolve
                scrollCollapse: true,
                searching: true,
                ajax: ajaxSettings,

                //// For 24-cell grid system
                //"dom": "<'row'<'col-sm-12'l><'col-sm-12'f>>" +
                //    "<'row'<'col-sm-24'tr>>" +
                //    "<'row'<'col-sm-10'i><'col-sm-4'p>>",

                // Custom no data message
                language: {
                    "emptyTable": "No log entries found"
                },

                columns: columnDefs

            };


            this.historyTable = $("#historyTable").DataTable(tableSettings);
        } else {
            this.historyTable.ajax.reload();
        }
    }

    expandViewButtonClick(viewName: string, viewSubject: string) {

        // Called from view builder, to expand a view
        var activeTab = $(".viewTabLi.active").attr("id");
        var reportTypeFilter: "All" | "Maps" = activeTab == "mapsTabLi" ? "Maps" : "All";


        this.modelServices.getNodeCommodities(this.modelId, viewSubject)
            .then(result => {

                this.reportCarouselConfig = {
                    modelId: this.modelId,
                    subject: viewSubject,
                    reportTypeFilter: reportTypeFilter,
                    initialViewName: viewName,
                    nodeCommodities: result
                }

                this.showReportCarousel = true;
            });
    }

    doRefreshNodeComments(nodePath) {

        this.commentsNodePathAndName = nodePath;
    }

    doRefreshRawNodeEditor(nodePath: string) {
        this.rawNodeEditorNodePathAndName = nodePath;
    }


    // Downloads selected views
    downloadSelectedViews(selector, nodePaths: string[]) {

        var reportIds = ViewManager.getViews($(selector), true);
        if (reportIds.length > 0) {

            this.downloadReportsModel = {
                mode: "bySubjectNode",
                modelId: this.modelId,
                singleSheet: false,
                format: "excel",
                reportNodePathAndNames: nodePaths,
                createPivots: false,
                reportNames: reportIds,
                recursive: false
            }
            this.showDownloadReportsDialog = true;
        } else
            bootbox.alert("No reports selected",
                () => { });

    }

    onDownloadReportsDialogClosed() {
        this.showDownloadReportsDialog = false;

    }

    // Refresh attachments tab
    doRefreshAttachments() {

        // Table renderer
        this.attachmentsTableRenderer.render($("#attachmentsTable"), null);
    }



    // Gets option to show palette or not
    getShowPaletteNodeCaptions() {
        const result = localStorage.getItem("showNodePaletteCaptions") || "true";
        const boolResult = result === "true";
        $("#paletteLabelsCheckbox").prop("checked", boolResult);
        return boolResult;
    }

    // Sets option to show palette or not
    setShowPaletteNodeCaptions(showThem) {
        localStorage.setItem("showNodePaletteCaptions", showThem);
    }

    // Palette labels checkbox click
    paletteLabelsCheckboxClick(e) {
        if ($(e.target).is(":checked"))
            this.setShowPaletteNodeCaptions("true");
        else
            this.setShowPaletteNodeCaptions("false");

        bootbox.alert("Refresh page for change to take effect");
    }

    // Refreshes the node spreadsheet
    doRefreshNodeSpreadsheet(nodePath) {


        const nodePathUrl = encodeURIComponent(nodePath);
        $.ajax(
            {
                url: `/api/1.0/nodespreadsheet?modelId=${this.modelId}&nodePath=${nodePathUrl}`,
                global: false, // Suppress global ajax notification
            })
            .done((data: any) => {

                // Create a backup of the data in case the users
                var dataArray = { value: data.value };
                // var readOnlyRows = data.readOnlyRows;

                // Define a function that will be passed to the handsontable to define if
                // a cell is read-only or not.  This is defined by the returned data.readOnlyRows list

                var cellsFunc = (row, col, prop) => {
                    var cellProperties = { readOnly: false };

                    if (data.readOnlyRows.indexOf(row) > -1) {
                        cellProperties.readOnly = true;
                    }
                    return cellProperties;
                };

                this.nodeDataSpreadsheetRenderer.drawTable(
                    $("#nodeSpreadsheetContainer"),
                    [dataArray],
                    "",
                    cellsFunc,
                );
                $("#saveNodeSpreadsheetChangesButton").toggleClass("disabled", true);
                $("#cancelNodeSpreadsheetChangesButton").toggleClass("disabled", true);

            });
    }

    // Save node spreadsheet changes click
    saveNodeSpreadsheetChangesButtonClick() {

        const nodePathAndName = this.modelTree.getActiveNode().pathAndName;
        const hot = this.nodeDataSpreadsheetRenderer.getTable();

        const data = hot.getData(0, 0, hot.countRows() - 1, hot.countCols() - 1);

        const url = "/api/1.0/nodespreadsheet";

        const model = {
            modelId: this.modelId,
            nodePath: nodePathAndName,
            value: JSON.stringify(data)
        };

        FetchWrapper.sendCommandAndHandle(url, { method: "post", body: JSON.stringify(model) })

            .then(() => {

                $("#saveNodeSpreadsheetChangesButton").toggleClass("disabled", true);
                $("#cancelNodeSpreadsheetChangesButton").toggleClass("disabled", true);
            });
    }

    // Refreshes the node variables tab
    doRefreshNodeVariables(nodeId) {

        //        this.showEditNodeDataDialog = true;
        this.editNodeDataModel = { modelId: this.modelId, nodePathAndName: nodeId };
    }

    /* Set element sizes for ones where we can't get the fuckin css to do it for us
      This is called on resize, and also after adminlte sidebar collapse/expand */
    setControlSizes() {

        const parent = $(".content-wrapper");

        const tree = $("#treeDiv");
        const footer = $("footer");

        const buttonsRow = $("#buttonsDiv");

        const mainHeader = $(".main-header");
        const header = $(".content-header");

        const margins = 12;

        const windowHeight = window.innerHeight; // $(window).height();

        const treeHeight = windowHeight -
            footer.outerHeight() -
            buttonsRow.outerHeight() -
            //            header.outerHeight() -

            mainHeader.outerHeight() -
            margins;

        //console.clear();
        //console.log('windowHeight', windowHeight);

        //console.log('buttonsRow.height()', buttonsRow.height());
        //console.log('$(window).height()', $(window).height());
        //console.log('footer.outerHeight()', footer.outerHeight());

        //console.log('parent.outerHeight()', parent.outerHeight());
        //console.log('parent.height()', parent.height());
        //console.log('mainHeader.outerHeight', mainHeader.outerHeight());
        //console.log('header.outerHeight()', header.outerHeight());
        //console.log('buttonsRow.outerHeight()', buttonsRow.outerHeight());

        //console.log('treeHeight', treeHeight);

        const viewDiv = $("#viewDiv");

        //console.log('*** WIDTHS ***');
        //console.log('parent.outerWidth()', parent.outerWidth());
        //console.log('viewDiv.outerWidth()', viewDiv.outerWidth());

        tree.height(treeHeight - 46); // For view type dropdown

        tree.width(parent.outerWidth() - viewDiv.outerWidth() - (margins));

        const diagramDiv = $("#diagramDiv");
        diagramDiv.width(viewDiv.width());

        const navTabs = $("#navTabs");
        const tagEditorInput = $("#diagramOptionsRow");
        diagramDiv.height(treeHeight - navTabs.height() - tagEditorInput.height());

        const ioChartsHeight = 175;

        const ioDiagramHeight = treeHeight - navTabs.height() - ioChartsHeight - 12;
        const ioChartsTop = ioDiagramHeight;

        const ioDiagramDiv = $("#ioDiagramDiv");
        ioDiagramDiv.width(viewDiv.width());
        ioDiagramDiv.height(ioDiagramHeight);

        const ioChartsDiv = $("#ioChartsDiv");
        ioChartsDiv.width(viewDiv.width());
        ioChartsDiv.css({ 'top': ioChartsTop + 162 + "px", 'background-color': "white" });
        ioChartsDiv.height(ioChartsHeight); //tree.height() - navTabs.height() - 200);
        //ioChartsDiv.style("color", "white");
    };

    refreshDiagramAsync(): Promise<NetworkDiagramBuilder> {
        if (this.modelTree) {

            const node = this.modelTree.getActiveNode();
            if (node) {

                const nodePath = (node.isFolder) ? node.pathAndName : node.path;
                this.saveDiagramState(nodePath);
                return this.getDiagramDataAsync(nodePath, {
                    showPalette: true, centerDiagram: false,
                    snapNodesToGrid: this.diagramOptions.snapNodesToGrid,
                    snapGridSize: this.diagramOptions.snapGridSize,
                    autoCreateKinkPoints: this.diagramOptions.autoCreateKinkPoints,
                    alwaysShowKinkPoints: true,
                    forceSimulationConfig: DiagramForceSimulationConfig.Default,
                    applyKinkPointsToLinks: true
                });
            }
        }
        return Promise.reject();
    }

    autoLayoutDiagram() {
        if (this.diagram)
            this.diagram.autoLayoutAllNodes();
    }

    snapDiagramNodesToGrid() {
        if (this.diagram)
            this.diagram.snapNodesToGrid(true,
                this.diagramOptions.snapGridSize);
    }

    setupTimePointControl(modelId) {
        // Download timepoints
        $.get(`/api/1.0/nodes/getnodedata?modelId=${modelId}&nodePathAndName=&variableName=GlobalModelTimeVector`)
            .done(data => {

                if (data && data.length > 0) {
                    const timePoints = data[0].value.map(d => d[1]);

                    if (timePoints) {


                        // Dropdown version:
                        $("#timepoint-edit").empty();
                        var optionList = document.getElementById("timepoint-edit") as HTMLSelectElement;
                        timePoints.forEach(option => {
                            optionList.add(new Option(option, option));
                        });

                        // Default value;
                        $("#timepoint-edit").val(timePoints[0]);

                        // Trigger refresh of view on change
                        $("#timepoint-edit").on("change",
                            (event) => {

                                var activeTab = $(".viewTabLi.active").attr("id");
                                this.viewTabChanged(activeTab);
                            });

                    }
                }
            });

    }

    setupSubTimeControl(modelId) {
        // Download timepoints
        $.get(`/api/1.0/nodes/getnodedata?modelId=${modelId}&nodePathAndName=&variableName=SubtimeNames`)
            .done((data) => {

                if (data && data.length > 0) {
                    const subTimes = data[0].value.map(d => d[0]);


                    $("#subtime-edit").empty();
                    var optionList = document.getElementById("subtime-edit") as HTMLSelectElement;

                    subTimes.forEach(option => {
                        optionList.add(new Option(option, option));
                    });

                    // Default value;
                    $("#subtime-edit").val(subTimes[0]);
                    $("#subtime-edit").prop("disabled", subTimes.length < 2);

                    // Trigger refresh of view on change
                    $("#subtime-edit").on("change",
                        (event) => {

                            var activeTab = $(".viewTabLi.active").attr("id");
                            this.viewTabChanged(activeTab);
                        });


                }
            });


    }

    getSelectionCount(): number {
        if (this.diagram)
            return this.diagram.getSelectedNodes().length;
        return 0;
    }

    getTreeSelectionCount(): number {
        if (this.modelTree)
            return this.modelTree.getSelectedNodes().length;
        return 0;
    }

    getDiagramSelectionCount(): number {
        return this.getSelectionCount();
    }

    createNodeTemplateFromTreeClick() {
        this.internalCreateNodeTempalte(this.modelTree.getSelectedNodes());

    }

    internalCreateNodeTempalte(selection: INodeObject[]) {
        if (!selection) {
            bootbox.alert("No nodes selected");
            return;
        }

        bootbox.prompt({

            title: `Create Node Template (${selection.length} nodes)`,
            content: "New node template",
            callback:
                (value) => {
                    if (value) {
                        this.modelActionsHandler.createNodeTemplate(selection, value)
                            .then(response => {
                                if (response.commandResponse.success) {
                                    //this.modelTree.activateNode(response.createdNodePathAndName, false)
                                    this.populateNodeTemplates(this.modelId);
                                    //                                    this.modelTree.refreshNodeChildren("\\Templates");
                                }

                            });
                    }
                }
        });

    }

    createNodeTemplateFromDiagramClick() {

        this.internalCreateNodeTempalte(this.diagram.getSelectedNodes());

    }

    populateNodeTemplates(modelId: string) {

        const searchUrl = this.modelServices.getNodeSearchUrl(modelId,
            {
                pathFilter: "\\Templates\\",
                nodeTypes: ["Template"],
                //               searchPathAndName: true
            });

        FetchWrapper.fetch(searchUrl, { method: "get" })
            .then(response => response.json())
            .then(response => {
                this.nodeTemplates = response.map(item => {
                    var template: INodeTemplate = { pathAndName: item.name, name: NodeObject.extractName(item.name) };
                    return template;
                });
            });
    }

    addNodeFromTemplateAsync(template: INodeTemplate): Promise<NetworkDiagramBuilder> {

        const activeNode = this.modelTree.getActiveNode();

        const position = { xPos: 0, yPos: 0 }; // So the auto-layout will set the position
        return this.modelActionsHandler.addNodeFromTemplate(activeNode.pathAndName, template.pathAndName, position)
            .then(response => {
                if (response.success)
                    return this.refreshDiagramAsync()
                return Promise.reject();
            });
    }

    goToNodeClick() {
        bootbox.prompt({
            title: "Navigate to node",
            content: this.modelTree.getActiveNode().pathAndName,

            callback: value => {
                if (value) {
                    this.nodeHyperlinkClickHandler(value, false);
                }
            }
        });
    }


    publishToDashboard() {

        this.publishToDashboardModel = {
            nodePathAndName: "",
            modelId: this.modelId,
        }
        this.showPublishToDashboardDialog = true;
    }

    onPublishToDashboardDialogClosed() {
        this.showPublishToDashboardDialog = false;
    }

    onDistributeSelectedDiagramNodesClick(modeStr: string) {

        this.showDistributeDiagramNodesDialog = true;

    }

    onDistributeDiagramNodesDialogClosed(dialogResult: string, options: IDistributeDiagramNodesOptions) {
        this.showDistributeDiagramNodesDialog = false;
        if (dialogResult === "ok") {
            var mode: NodeDistributionMode;
            switch (options.modeStr.toLowerCase()) {
                case "horizontally": mode = NodeDistributionMode.horizontally;
                    break;
                case "vertically": mode = NodeDistributionMode.vertically;
                    break;
                default:
                    mode = NodeDistributionMode.obliquely;
                    break;

            }

            this.diagram.distributeNodes(mode, options.distanceX, options.distanceY);
        }

    }

    exportDiagramAsync(nodePathAndName: string, exportConfig: IExportNetworkDiagramConfig, exporter: SvgExporter, zipBuilder: IZipBuilder)
        : Promise<NetworkDiagramBuilder> {

        return this.showDiagramAsync(nodePathAndName, this.getDiagramOptions(false, exportConfig.centerDiagrams))
            .then(async diagram => {

                const svg = document.getElementById("diagramSVG")
                const dims = this.getDimensionsFunc("#diagramSVG");

                var doAddFileFunc = async (canvas: HTMLCanvasElement) => {

                    let nodePaths: string[];
                    if (exportConfig.recurseSectors)
                        nodePaths = NodeObject.extractPaths(nodePathAndName);
                    else
                        nodePaths = [NodeObject.extractName(nodePathAndName)];

                    //                    if (exportConfig.recurseSectors)

                    if (diagram.nodes.length > 0) {
                        await zipBuilder.addCanvasFileAsync(nodePaths, 'png', canvas)
                    }
                };

                await exporter.generateSvgAsync(svg, dims.width, dims.height)
                    .then(async canvas => {
                        await doAddFileFunc(canvas)
                            //                        await zipBuilder.addCanvasFileAsync(nodePaths, 'png', canvas)
                            .then(() => d3.selectAll("svg > *").remove())
                            .then(async () => {

                                // Then children, if specified
                                if (exportConfig.recurseSectors) {

                                    var searchUrl =
                                        this.modelServices.getNodeSearchUrl(this.modelId,
                                            {
                                                nodeTypes: ["Sector"],
                                                recursive: true,
                                                searchNameOnly: "",
                                                pathFilter: nodePathAndName + "\\",
                                                searchPathAndName: ""
                                            });

                                    await FetchWrapper.fetch(searchUrl, { method: "get" })
                                        .then(response => response.json())
                                        .then(async (response: INodeName[]) => {

                                            for await (const p of response) {
                                                await this.exportDiagramAsync(p.name, exportConfig, exporter, zipBuilder);
                                            };
                                        });

                                }
                            });

                    });

                return diagram;

            });

    }


    async onExportNetworkDiagramDialogClosed(response: string, value: IExportNetworkDiagramConfig) {

        this.showExportNetworkDiagramDialog = false;

        if (response == "ok") {
            const node = this.modelTree.getSelectedNodes()[0];
            this.saveDiagramState(node.pathAndName);

            var zipBuilder = new ZipBuilder();
            const exporter = new SvgExporter();

            var notification = this.userNotifier.showBusyNotification("Building export file...");

            await this.exportDiagramAsync(node.pathAndName, value, exporter, zipBuilder)
                .then(() => {
                    if (zipBuilder.getFileCount() > 0)
                        zipBuilder.downloadAsync(`${this.modelId} Network Diagrams.zip`);
                    else
                        bootbox.alert("No diagrams found");
                })
                .then(() => this.showDiagramAsync(node.pathAndName, this.getDiagramOptions()))
                .then(() => this.userNotifier.clear(notification));
        };
    }

    async onExportNetworkDiagramClick() {
        this.exportNetworkDiagramConfig.modelId = this.modelId;
        this.exportNetworkDiagramConfig.rootSector = this.modelTree.getSelectedNodes()[0].pathAndName;
        this.showExportNetworkDiagramDialog = true;
    }


    forceNumberFromString(val: any): number {

        // Moronic casting because input can change number to a string
        let result: number = val;
        if (typeof val === "string")
            result = +val;
        return result;

    }

    getDiagramOptions(showPalette: boolean = true, centerDiagram: boolean = false): NetworkDiagramConfig {


        return {
            centerDiagram: centerDiagram,
            showPalette: showPalette,
            snapGridSize: this.forceNumberFromString(this.diagramOptions.snapGridSize),
            snapNodesToGrid: this.diagramOptions.snapNodesToGrid,
            autoCreateKinkPoints: this.diagramOptions.autoCreateKinkPoints,
            alwaysShowKinkPoints: true,
            forceSimulationConfig: DiagramForceSimulationConfig.Default,
            applyKinkPointsToLinks: true
        }

    }

    onDiagramOptionsDialogClosed(dialogResult: string, options: INetworkDiagramOptions) {
        this.showDiagramOptionsDialog = false;
        if (dialogResult === "ok") {
            this.diagram.buildConfig.snapGridSize = this.forceNumberFromString(options.snapGridSize);
            this.diagram.buildConfig.snapNodesToGrid = options.snapNodesToGrid;
            this.diagram.buildConfig.autoCreateKinkPoints = options.autoCreateKinkPoints;

            localStorage.setItem("modelDiagram_snapNodesToGrid", `${this.diagram.buildConfig.snapNodesToGrid}`);
            localStorage.setItem("modelDiagram_snapGridSize", `${this.diagram.buildConfig.snapGridSize}`);
            localStorage.setItem("modelDiagram_autoCreateKinkPoints", `${this.diagram.buildConfig.autoCreateKinkPoints}`);

        }

    }

    resetKinkPoints() {
        this.diagram.resetKinkPoints();
    }

    private refreshUndoRedo(modelId: string) {
        FetchWrapper.fetch(`/api/1.0/query/GetUndoRedoPeeksQuery?modelId=${modelId}`, { method: "get" })
            .then(response => response.json())
            .then(cmd => {
                this.undoPeekCmd = cmd.undoPeek;
                this.redoPeekCmd = cmd.redoPeek;
            });
    }

    undoClick() {
        const payload = JSON.stringify({ modelId: this.modelId });
        var notification = this.userNotifier.showBusyNotification(`Undoing ${this.undoPeekCmd.description}...`);
        FetchWrapper.sendCommandAndHandle(`/api/1.0/command/undo`, { method: "post", body: payload })
            .then(response => {
                this.userNotifier.clear(notification);
                if (response.success)
                    // Todo do this without flicker
                    this.refreshDiagramAsync();
            });
    }

    redoClick() {
        const payload = JSON.stringify({ modelId: this.modelId });
        var notification = this.userNotifier.showBusyNotification(`Redoing ${this.redoPeekCmd.description}...`);
        FetchWrapper.sendCommandAndHandle(`/api/1.0/command/redo`, { method: "post", body: payload })
            .then(response => {
                this.userNotifier.clear(notification);
                if (response.success)
                    // Todo do this without flicker
                    this.refreshDiagramAsync();
            });

    }

    getUndoPeekHint(): string {
        if (this.undoPeekCmd)
            return `Undo ${this.undoPeekCmd.description}`;
        else
            return "Undo currently unavailable";
    }

    getRedoPeekHint(): string {
        if (this.redoPeekCmd)
            return `Redo ${this.redoPeekCmd.description}`;
        else
            return "Redo currently unavailable";

    }

}


// WEBPACK FOOTER //
// ./ClientApp/components/model-viewer/model-viewer.ts